import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpPut, httpGet, httpDelete } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'

const GET_ANNOUNCEMENTS = makeKeys('GET_ANNOUNCEMENTS')
const GET_ACTIVE_ANNOUNCEMENTS = makeKeys('GET_ACTIVE_ANNOUNCEMENTS')
const CREATE_ANNOUNCEMENT = makeKeys('CREATE_ANNOUNCEMENT')
const UPDATE_ANNOUNCEMENT = makeKeys('UPDATE_ANNOUNCEMENT')
const MARK_END_ANNOUNCEMENT = makeKeys('MARK_END_ANNOUNCEMENT')
const DELETE_ANNOUNCEMENT = makeKeys('DELETE_ANNOUNCEMENT')

const GET_MAINTENANCE_TIMES = makeKeys('GET_MAINTENANCE_TIMES')
const CREATE_MAINTENANCE_TIME = makeKeys('CREATE_MAINTENANCE_TIME')
const UPDATE_MAINTENANCE_TIME = makeKeys('UPDATE_MAINTENANCE_TIME')
const MARK_END_MAINTENANCE_TIME = makeKeys('MARK_END_MAINTENANCE_TIME')
const DELETE_MAINTENANCE_TIME = makeKeys('DELETE_MAINTENANCE_TIME')

const GET_ADMIN_USERS = makeKeys('GET_ADMIN_USERS')
const CREATE_ADMIN_USER = makeKeys('CREATE_ADMIN_USER')
const UPDATE_ADMIN_USER = makeKeys('UPDATE_ADMIN_USER')
const MARK_END_ADMIN_USER = makeKeys('MARK_END_ADMIN_USER')
const DELETE_ADMIN_USER = makeKeys('DELETE_ADMIN_USER')

export const getAnnouncements = makeAction(GET_ANNOUNCEMENTS.REQUEST)
export const getActiveAnnouncements = makeAction(GET_ACTIVE_ANNOUNCEMENTS.REQUEST)
export const createAnnouncement = makeAction(CREATE_ANNOUNCEMENT.REQUEST, 'data', 'onSuccess')
export const updateAnnouncement = makeAction(UPDATE_ANNOUNCEMENT.REQUEST, 'data', 'onSuccess')
export const markEndAnnouncement = makeAction(MARK_END_ANNOUNCEMENT.REQUEST, 'id', 'onSuccess')
export const deleteAnnouncement = makeAction(DELETE_ANNOUNCEMENT.REQUEST, 'id', 'onSuccess')
export const getMaintenanceTimes = makeAction(GET_MAINTENANCE_TIMES.REQUEST)
export const createMaintenanceTime = makeAction(CREATE_MAINTENANCE_TIME.REQUEST, 'data', 'onSuccess')
export const updateMaintenanceTime = makeAction(UPDATE_MAINTENANCE_TIME.REQUEST, 'data', 'onSuccess')
export const markEndMaintenanceTime = makeAction(MARK_END_MAINTENANCE_TIME.REQUEST, 'id', 'onSuccess')
export const deleteMaintenanceTime = makeAction(DELETE_MAINTENANCE_TIME.REQUEST, 'id', 'onSuccess')
export const getAdminUsers = makeAction(GET_ADMIN_USERS.REQUEST)
export const createAdminUser = makeAction(CREATE_ADMIN_USER.REQUEST, 'data', 'onSuccess')
export const updateAdminUser = makeAction(UPDATE_ADMIN_USER.REQUEST, 'data', 'onSuccess')
export const markEndAdminUser = makeAction(MARK_END_ADMIN_USER.REQUEST, 'id', 'onSuccess')
export const deleteAdminUser = makeAction(DELETE_ADMIN_USER.REQUEST, 'id', 'onSuccess')

const getAnnouncementsSuccess = makeAction(GET_ANNOUNCEMENTS.SUCCESS, 'data')
const getActiveAnnouncementsSuccess = makeAction(GET_ACTIVE_ANNOUNCEMENTS.SUCCESS, 'data')
const getMaintenanceTimesSuccess = makeAction(GET_MAINTENANCE_TIMES.SUCCESS, 'data')
const getAdminUsersSuccess = makeAction(GET_ADMIN_USERS.SUCCESS, 'data')

const getActiveAnnouncementsFailure = makeAction(GET_ACTIVE_ANNOUNCEMENTS.FAILURE)

const systemPath = path => path ? urlWithPrefix(`system/${path}`) : urlWithPrefix('system')

function* getAnnouncementsRequest(action) {
  try {
    yield put(appLoading('Loading Announcements'))
    const response = yield httpGet(systemPath('announcements'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAnnouncementsSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Announcements Error!'))
    }
    yield put(appLoaded())
  }
}

function* getActiveAnnouncementsRequest(action) {
  try {
    const response = yield httpGet(systemPath('announcements/active'))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getActiveAnnouncementsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getActiveAnnouncementsFailure())
  }
}

function* createAnnouncementRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Creating Announcement'))
    const response = yield httpPost(systemPath('announcements'), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (response.data.message) {
          yield put(toastSuccess(response.data.message))
          yield put(getAnnouncements())
          onSuccess()
        } else{
          yield put(toastSuccess('Create Announcement Success'))
        }
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create Announcement Error!'))
    }
    yield put(appLoaded())
  }
}

function* updateAnnouncementRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Updating Announcement'))
    const response = yield httpPut(systemPath(`announcements/${data.id}`), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(toastSuccess('Update Announcement Success'))
        yield put(getAnnouncements())
        onSuccess()
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update Announcement Error!'))
    }
    yield put(appLoaded())
  }
}

function* deleteAnnouncementRequest(action) {
  const { id, onSuccess } = action.payload
  try {
    yield put(appLoading('Delete Announcement'))
    const response = yield httpDelete(systemPath(`announcements/${id}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(getAnnouncements())
        yield put(toastSuccess('Delete Announcement Success'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Delete Announcement Error!'))
    }
    yield put(appLoaded())
  }
}

function* markEndAnnouncementRequest(action) {
  const { id, onSuccess } = action.payload
  try {
    yield put(appLoading('Marking end Announcement'))
    const response = yield httpPut(systemPath(`announcements/${id}/markEnd`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(getAnnouncements())
        yield put(toastSuccess('Mark End Announcement Success'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Mark End Announcement Error!'))
    }
    yield put(appLoaded())
  }
}

function* getMaintenanceTimesRequest(action) {
  try {
    yield put(appLoading('Loading Maintenance Times'))
    const response = yield httpGet(systemPath('maintenanceTimes'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMaintenanceTimesSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Maintenance Times Error!'))
    }
    yield put(appLoaded())
  }
}

function* createMaintenanceTimeRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Creating Maintenance Time'))
    const response = yield httpPost(systemPath('maintenanceTimes'), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (response.data.message) {
          yield put(toastSuccess(response.data.message))
          yield put(getMaintenanceTimes())
          onSuccess()
        } else{
          yield put(toastSuccess('Create Maintenance Time Success'))
        }
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create Maintenance Time Error!'))
    }
    yield put(appLoaded())
  }
}

function* updateMaintenanceTimeRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Updating Maintenance Time'))
    const response = yield httpPut(systemPath(`maintenanceTimes/${data.id}`), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(toastSuccess('Update Maintenance Time Success'))
        yield put(getMaintenanceTimes())
        onSuccess()
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update Maintenance Time Error!'))
    }
    yield put(appLoaded())
  }
}

function* deleteMaintenanceTimeRequest(action) {
  const { id, onSuccess } = action.payload
  try {
    yield put(appLoading('Delete Maintenance Time'))
    const response = yield httpDelete(systemPath(`maintenanceTimes/${id}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(getMaintenanceTimes())
        yield put(toastSuccess('Delete Maintenance Time Success'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Delete Maintenance Time Error!'))
    }
    yield put(appLoaded())
  }
}

function* markEndMaintenanceTimeRequest(action) {
  const { id, onSuccess } = action.payload
  try {
    yield put(appLoading('Marking end Maintenance Time'))
    const response = yield httpPut(systemPath(`maintenanceTimes/${id}/markEnd`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(getMaintenanceTimes())
        yield put(toastSuccess('Mark End Maintenance Time Success'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Mark End Maintenance Time Error!'))
    }
    yield put(appLoaded())
  }
}

function* getAdminUsersRequest(action) {
  try {
    yield put(appLoading('Loading Admin Users'))
    const response = yield httpGet(systemPath('adminUsers'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAdminUsersSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Admin Users Error!'))
    }
    yield put(appLoaded())
  }
}

function* createAdminUserRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Creating Admin User'))
    const response = yield httpPost(systemPath('adminUsers'), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (response.data.message) {
          yield put(toastSuccess(response.data.message))
          yield put(getAdminUsers())
          onSuccess()
        } else{
          yield put(toastSuccess('Create Admin User Success'))
        }
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create Admin User Error!'))
    }
    yield put(appLoaded())
  }
}

function* updateAdminUserRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Updating Admin User'))
    const response = yield httpPut(systemPath(`adminUsers/${data.id}`), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(toastSuccess('Update Admin User Success'))
        yield put(getAdminUsers())
        onSuccess()
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update Admin User Error!'))
    }
    yield put(appLoaded())
  }
}

function* deleteAdminUserRequest(action) {
  const { id, onSuccess } = action.payload
  try {
    yield put(appLoading('Delete Admin User'))
    const response = yield httpDelete(systemPath(`adminUsers/${id}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(getAdminUsers())
        yield put(toastSuccess('Delete Admin User Success'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Delete Admin User Error!'))
    }
    yield put(appLoaded())
  }
}

function* markEndAdminUserRequest(action) {
  const { id, onSuccess } = action.payload
  try {
    yield put(appLoading('Marking End Admin User'))
    const response = yield httpPut(systemPath(`adminUsers/${id}/markEnd`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onSuccess()
        yield put(getAdminUsers())
        yield put(toastSuccess('Mark End Admin User Success'))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Mark End Admin User Error!'))
    }
    yield put(appLoaded())
  }
}

const ADMIN_UPDATE_NOT_GR_BASE = makeKeys('ADMIN_UPDATE_NOT_GR_BASE')
export const adminUpdateNotGRBase = makeAction(ADMIN_UPDATE_NOT_GR_BASE.REQUEST, 'data')
function* adminUpdateNotGRBaseRequest(action) {
  const { data } = action.payload
  try {
    yield put(appLoading(''))
    const response = yield httpPut(systemPath('Billing/UpdateNewDocNotGrBaseInv'), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Update success.'))
    }
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update fail.'))
    }
    yield put(appLoaded())
  }
}

export function* watchSystemSaga() {
  yield takeLatest(GET_ANNOUNCEMENTS.REQUEST, getAnnouncementsRequest)
  yield takeLatest(GET_ACTIVE_ANNOUNCEMENTS.REQUEST, getActiveAnnouncementsRequest)
  yield takeLatest(CREATE_ANNOUNCEMENT.REQUEST, createAnnouncementRequest)
  yield takeLatest(UPDATE_ANNOUNCEMENT.REQUEST, updateAnnouncementRequest)
  yield takeLatest(DELETE_ANNOUNCEMENT.REQUEST, deleteAnnouncementRequest)
  yield takeLatest(MARK_END_ANNOUNCEMENT.REQUEST, markEndAnnouncementRequest)
  yield takeLatest(GET_MAINTENANCE_TIMES.REQUEST, getMaintenanceTimesRequest)
  yield takeLatest(CREATE_MAINTENANCE_TIME.REQUEST, createMaintenanceTimeRequest)
  yield takeLatest(UPDATE_MAINTENANCE_TIME.REQUEST, updateMaintenanceTimeRequest)
  yield takeLatest(DELETE_MAINTENANCE_TIME.REQUEST, deleteMaintenanceTimeRequest)
  yield takeLatest(MARK_END_MAINTENANCE_TIME.REQUEST, markEndMaintenanceTimeRequest)
  yield takeLatest(GET_ADMIN_USERS.REQUEST, getAdminUsersRequest)
  yield takeLatest(CREATE_ADMIN_USER.REQUEST, createAdminUserRequest)
  yield takeLatest(UPDATE_ADMIN_USER.REQUEST, updateAdminUserRequest)
  yield takeLatest(DELETE_ADMIN_USER.REQUEST, deleteAdminUserRequest)
  yield takeLatest(MARK_END_ADMIN_USER.REQUEST, markEndAdminUserRequest)
  yield takeLatest(ADMIN_UPDATE_NOT_GR_BASE.REQUEST, adminUpdateNotGRBaseRequest)
}

const initial = {
  listAnnouncements: { data: [], loading: false },
  listActiveAnnouncements: { data: [], loading: false },
  listMaintenanceTimes: { data: [], loading: false },
  listAdminUsers: { data: [], loading: false },
}

export default createReducer(initial, state => ({
  [GET_ANNOUNCEMENTS.REQUEST]: () => ({
    ...state,
    listAnnouncements: { data: [], loading: true }
  }),
  [GET_ANNOUNCEMENTS.SUCCESS]: (data) => ({
    ...state,
    listAnnouncements: { data: data.data, loading: false }
  }),
  [GET_ACTIVE_ANNOUNCEMENTS.REQUEST]: () => ({
    ...state,
    listActiveAnnouncements: { data: [], loading: true }
  }),
  [GET_ACTIVE_ANNOUNCEMENTS.SUCCESS]: (data) => ({
    ...state,
    listActiveAnnouncements: { data: data.data, loading: false }
  }),
  [GET_ACTIVE_ANNOUNCEMENTS.FAILURE]: () => ({
    ...state,
    listActiveAnnouncements: { data: [], loading: false }
  }),
  [GET_MAINTENANCE_TIMES.REQUEST]: () => ({
    ...state,
    listMaintenanceTimes: { data: [], loading: true }
  }),
  [GET_MAINTENANCE_TIMES.SUCCESS]: (data) => ({
    ...state,
    listMaintenanceTimes: { data: data.data, loading: false }
  }),
  [GET_ADMIN_USERS.REQUEST]: () => ({
    ...state,
    listAdminUsers: { data: [], loading: true }
  }),
  [GET_ADMIN_USERS.SUCCESS]: (data) => ({
    ...state,
    listAdminUsers: { data: data.data, loading: false }
  }),
}))